import * as React from 'react';
import * as classnames from 'classnames';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ResponsiveModal } from '@estee/elc-responsive-modal';
import { ProductNotifyMeConfirmationContent } from './ProductNotifyMeConfirmationContent';
import { RemoveIcon } from '@estee/elc-icons';
import { getProductNotifyMePopupUnderlayStyle } from '../../domain/services/ProductNotifyMeService';
import { translate } from '@estee/elc-service';

export enum Translations {
    continueShoppingButtonLabel
}

export type ITranslations = { [key in keyof typeof Translations]: string };

export interface IProductNotifyMeConfirmation {
    productDisplayName: string;
    confirmationContent: string;
    confirmationContentTitle: string;
    isPopUpOpen: boolean;
    onCloseButtonClick(): void;
    zIndex?: number;
    translations?: ITranslations;
}

const Wrapper = styled.div`
    width: 100%;
`;

const ProductNotifyMeConfirmationModal = styled(ResponsiveModal)`
    padding: 0;
`;

const ProductNotifyMeConfirmationCloseButton = styled.button`
    cursor: pointer;
    float: right;
    border: none;
    outline: none;
    margin: 10px;
`;

const productNotifyMeConfirmationWrapperClassNames = classnames(
    'elc-product-notify-me-confirmation-wrapper',
    'js-product-notify-me-confirmation-wrapper'
);

const productNotifyMeConfirmationCloseButtonClassNames = classnames(
    'elc-product-notify-me-confirmation-close-button',
    'js-product-notify-me-confirmation-close-button'
);

const productNotifyMeConfirmationCloseButtonIconClassNames = classnames(
    'elc-product-notify-me-confirmation-close-button-icon',
    'js-product-notify-me-confirmation-close-button-icon'
);

@translate(['continueShoppingButtonLabel'])
@observer
export class ProductNotifyMeConfirmation extends React.Component<IProductNotifyMeConfirmation> {
    public render() {
        const {
            isPopUpOpen,
            onCloseButtonClick,
            productDisplayName,
            confirmationContent,
            confirmationContentTitle,
            zIndex
        } = this.props;

        const { continueShoppingButtonLabel } = this.props.translations as ITranslations;

        return (
            <Wrapper>
                <ProductNotifyMeConfirmationModal
                    className={productNotifyMeConfirmationWrapperClassNames}
                    title={productDisplayName}
                    isOpen={isPopUpOpen}
                    deactivateModal={onCloseButtonClick}
                    underlayStyle={getProductNotifyMePopupUnderlayStyle(zIndex, 1)}
                >
                    <ProductNotifyMeConfirmationCloseButton
                        className={productNotifyMeConfirmationCloseButtonClassNames}
                        onClick={onCloseButtonClick}
                    >
                        <RemoveIcon
                            className={productNotifyMeConfirmationCloseButtonIconClassNames}
                        />
                    </ProductNotifyMeConfirmationCloseButton>
                    <ProductNotifyMeConfirmationContent
                        content={confirmationContent}
                        contentTitle={confirmationContentTitle}
                        onContinueShoppingButtonClick={onCloseButtonClick}
                        continueShoppingButtonLabel={continueShoppingButtonLabel}
                    />
                </ProductNotifyMeConfirmationModal>
            </Wrapper>
        );
    }
}
